import axios from "axios";

const createInstantLuckyDraw = ({
  title,
  description,
  imgUrl,
  tncUrl,
  metadata,
  productId,
  startAt,
  endAt,
  game,
  status,
}) => {
  const body = {
    title: title,
    description: description,
    imgUrl: imgUrl,
    tncUrl: tncUrl,
    customField: metadata,
    productId: productId,
    startAt: startAt,
    endAt: endAt,
    game: game,
    status: status,
  };

  return new Promise((resolve, reject) => {
    axios
      .post("/campaignV2/customer/instantLuckyDraw/create", body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default createInstantLuckyDraw;
